import React from 'react';
import { useParams } from 'react-router-dom';
import EstimateLineItems from '@/components/estimates/EstimateLineItems';

const EditEstimateItemsPage = () => {
  const { id } = useParams<{ id: string }>();

  console.log('[EditEstimateItemsPage] Component loaded with params:', { id });

  if (!id) {
    console.log('[EditEstimateItemsPage] No ID found in params');
    return null;
  }

  console.log('[EditEstimateItemsPage] Rendering EstimateLineItems with ID:', id);

  // EstimateLineItems uses PageLayout internally, no wrapper needed
  return <EstimateLineItems estimateId={id} />;
};

export default EditEstimateItemsPage;
